<template>
  <vs-popup :active="isActive" title="Assign" v-on:update:active="UpdateActive">
    <div style="height: 500px">
      <feather-icon
        v-if="false"
        icon="AwardIcon"
        class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
        svgClasses="h-8 w-8"
        style="float: left; margin-right: 10px"
      ></feather-icon>
      <h3></h3>
      <div style="clear: both"></div>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/1">
          Assignee:<br />
          <UserDropdownSelector v-if="isActive" v-model="SelectedUsers">
          </UserDropdownSelector>
        </div>
      </div>
      <div class="vx-row" v-if="ShowAssignmentTypes">
        <div class="vx-col w-full lg:w-1/1">
          <br />
          Assignment type:<br />
          <v-select
            label="Assignment Type"
            taggable
            :options="assignmentTypes"
            v-model="assignmentType"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/1">
          <br />
          Comment:<br />
          <vs-textarea label="Add Comment" class="mb-2" v-model="comment" />
          <vs-button size="small" style="float: right" @click="saveAssignment"
            >Save</vs-button
          >
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import UserDropdownSelector from "@/views/components/extra-components/users/UserDropdownSelector.vue";
import AssignmentsService from "@/assignments/assignmentsService.js";
import vSelect from "vue-select";

export default {
  data() {
    return {
      comment: "",
      score: 0,
      SelectedUsers: null,
      assignmentTypes: [
        "Owner",
        "Read",
        "Instructor",
        "Instructed",
        "Supporter",
        "Contributor",
        "Improvement Request"
      ],
      assignmentType: null,
    };
  },
  methods: {
    saveAssignment() {
      var instance = this;

      var newDate = new Date();
      newDate.setDate(newDate.getDate() + 7);

      AssignmentsService.assignUsers(
        instance.SelectedUsers.Id,
        instance.ItemId,
        instance.ItemType,
        newDate,
        0,
        0,
        instance.comment,
        0,
        instance.assignmentType
      ).then(function () {
        instance.$vs.notify({
          time: 8000,
          title: "Success",
          text: "Assignment updated.",
          color: "success",
          iconPack: "feather",
          icon: "icon-success-circle",
        });

        instance.$set(instance, "SelectedUsers", null);
        instance.$set(instance, "score", 0);
        instance.$set(instance, "comment", "");
        instance.$set(instance, "assignmentType", null);

        instance.$set(instance, "Save", true);
        instance.$emit("UpdateActive", false);
      });
    },
  },
  props: [
    "isActive",
    "assignment",
    "UpdateActive",
    "ItemId",
    "ItemType",
    "ShowAssignmentTypes",
    "PreselectedUsers",
    "PreselectedAssignmentType"
  ],
  computed: {
    isAssignmentCalculated: {
      get: function () {
        return this.isActive;
      },
      set: function (value) {
        this.$emit("isActive", value);
        this.UpdateActive(value);
      },
    },
  },
  watch: {
    PreselectedUsers: {
      handler: function (newVal) {
        this.SelectedUsers = newVal; // Ensure this matches your data property
      },
      immediate: true,
    },
    PreselectedAssignmentType: {
      handler: function (newVal) {
        this.assignmentType = newVal; // Ensure this matches your data property
      },
      immediate: true,
    },
    SelectedUsers: {
      handler: function(newVal){
        this.$emit("UserSelectionChanged", newVal);
      }
    }
  },
  components: { UserDropdownSelector, vSelect },
};
</script>
